import { take } from "../util/takePayload";
export const fromGql = (gqlVenue) => take(gqlVenue, 'id', 'name', 'logoUrl', 'locale', 'currency', 'state', 'city', 'street1', 'street2', 'timeZone');
//# sourceMappingURL=CheckoutVenue.js.map